import StorefrontShop from 'api/StorefrontShop';
import ACTIONS from 'state/constants';
import Log from 'utils/Log';

export const fetchPaymentSettings = () => async dispatch => {
  dispatch({ type: ACTIONS.FETCH_PAYMENT_SETTINGS_REQUEST });
  try {
    const paymentSettings = await StorefrontShop.fetchPaymentSettings();
    dispatch({ type: ACTIONS.FETCH_PAYMENT_SETTINGS_SUCCESS, payload: { paymentSettings } });
  } catch (error) {
    Log.error(error, 'Fetching Payment Settings failed.');
    dispatch({ type: ACTIONS.FETCH_PAYMENT_SETTINGS_FAILURE, payload: { error } });
  }
};
